













import { Component, Vue } from 'vue-property-decorator';
import firebase from '@/firebase';

@Component({
  computed: {
    isAdmin(): boolean {
      return this.$route.path.indexOf('/admin') === 0 || this.$route.params.admin === 'true';
    }
  }
})
export default class Logout extends Vue {

  public async signout() {
    try {
      await firebase.auth().signOut();
    } catch (e) {
      console.error(e);
    }
    this.$router.push('/students/login');
  }

}
